import { ADMINISTRATOR, MANAGER_PLUS, MANAGER, BASE_USER, CONTRIBUTOR, CONTRIBUTOR_PLUS, RESTRICTED_CONTRIBUTOR, BASE_CHECKER, SUPERVISOR } from "@/constants/roles";
import {
    hasJobApprovalWorkflowHold,
    isJobApprovalRejected,
    isJobAwaitingApproval,
} from "@/constants/job-statuses";

export const haveAccessToEnforceJobAuth = (permissions) => {
    return permissions.find(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER].includes(item.roleId)) ? true : false;
}

export const haveAccessToCompleteJob = (permissions) => {
    return permissions.find(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId)) ? true : false;
}

export const haveAccessToScheduleSuspension = (permissions) => {
    return permissions.find(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId)) ? true : false;
}

export const haveAccessToViewLeaveReplacement = (permissions) => {
    return permissions.find(item => [ADMINISTRATOR, MANAGER, MANAGER_PLUS, SUPERVISOR].includes(item.roleId)) ? true : false;
}

export const haveAccessToManageUserSitePermissions = (permissions) => {
    return permissions.find(item => [ADMINISTRATOR, MANAGER, MANAGER_PLUS, SUPERVISOR].includes(item.roleId)) ? true : false;
}

export const haveAnyNonBaseRole = (roleIds) => {
    return (roleIds || []).some(roleId => ![BASE_USER, BASE_CHECKER].includes(roleId));
}

export const haveDefaultBulkMetadataAccessRole = (roleIds) => {
    return (roleIds || []).some(roleId => [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR].includes(roleId));
}

export const haveAccessToChangeAccountInformation = (permissions) => {
    return permissions.find(item => item.roleId == ADMINISTRATOR) ? true : false;
}

export const haveAccessDeleteOrCreateOrRestoreAccount = (permissions) => {
    return permissions.find(item => item.roleId == ADMINISTRATOR) ? true : false;
}

export const haveAccessToEditSite = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR, SUPERVISOR].includes(permission.roleId) ? true : false;
}

export const haveAnyManagerRole = (permissions) => {
    return permissions.find(item => [MANAGER, MANAGER_PLUS].includes(item.roleId)) ? true : false;
}

export const haveAccessToEditSiteDetails = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR, SUPERVISOR].includes(permission.roleId) ? true : false;
}

export const haveAccessToCreateSite = (permissions) => {
    const permission = permissions.find(item => item.roleId == ADMINISTRATOR);

    return permission ? true : false;
}

export const haveAccessToDeleteSite = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR].includes(permission.roleId) ? true : false;
}

export const haveAccessToRestoreSite = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR].includes(permission.roleId) ? true : false;
}

export const haveAccessToEditSiteFilters = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(permission.roleId) ? true : false;
}

export const haveAccessToEditSiteWatermarks = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(permission.roleId) ? true : false;
}

export const haveAccessToToggleFixedCategories = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR].includes(permission.roleId) ? true : false;
}

export const haveAccessToManageFixedCategories = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(permission.roleId) ? true : false;
}

export const haveAccessToViewFixedCategories = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(permission.roleId) ? true : false;
}

export const haveAccessToChangeUsersInfo = (permissions, user) => {
    return permissions && user ? permissions.find(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId)) && user.adUser == false ? true :
        permissions && permissions.find(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId)) ? true : false : false;
}

export const haveAccessToChangeUsersEmailAddress = (maxUserRole, newUser) => {
    return newUser
        ? [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(maxUserRole)
        : maxUserRole === ADMINISTRATOR;
}

export const haveAccessToChangeUsersBookSetting = (permissions, user) => {
    return permissions && user ? permissions.find(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId)) ? true : false : false;
}

export const haveAccessToChangeOwnFeatureSettings = (permissions) => {
    return (permissions || []).some(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER].includes(item.roleId));
}

export const haveAccessToChangeRoles = (permissions, users, siteId) => {
    return permissions && users && permissions.find(item => siteId == item.siteId && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId)) ?
        users.filter(user => user.adUser == false && user.active == true) : null;
}

export const haveAccessToDeleteAndRestoreUsers = (permissions) => {
    return permissions.find(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId)) ? true : false;
}

export const haveAbilityRemoveUsers = (permissions, user) => {
    return permissions && user && permissions.find(item => [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId)) && user.adUser == false ? true : false;
}

export const haveAbilityToCreateUser = (permissions, siteId) => {
    const permission = permissions.find(item => item.siteId == siteId);

    return permission && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(permission.roleId);
}

export const haveAbilityToDownloadSources = (permissions, documents) => {
    documents = documents ? documents.map(item => { return { ...item, ...item.documentFile, ...item.document } }) : null

    const documentItems = documents && permissions ?
        documents.filter(doc => permissions.find(item => item.siteId == doc.siteId &&
            ([ADMINISTRATOR, MANAGER_PLUS, MANAGER, CONTRIBUTOR, CONTRIBUTOR_PLUS, SUPERVISOR].includes(item.roleId) || (item.roleId == RESTRICTED_CONTRIBUTOR && item.site.useIndividualDocumentPermission ? !doc.restrictAccessToSource : item.site.normalDocumentDownloadForRestrictedUser))
            && (doc.sourceFileName || (doc.documentFile && doc.documentFile.sourceFileName)))) : null;

    return documentItems;
}

export const haveAbilityToDownloadSource = (permissions, document) => {
    document = { ...document, ...document.documentFile, ...document.document };
    const permission = permissions.find(item => item.siteId == document.siteId);

    return permission &&
        ([ADMINISTRATOR, MANAGER_PLUS, MANAGER, CONTRIBUTOR, CONTRIBUTOR_PLUS, SUPERVISOR].includes(permission.roleId)
            || (permission.roleId == RESTRICTED_CONTRIBUTOR && permission.site.useIndividualDocumentPermission ? !document.restrictAccessToSource : permission.site.normalDocumentDownloadForRestrictedUser));
}

export const haveAbilityToChangeCategory = (permissions, documents) => {
    const permissionItems = permissions && documents ? documents.filter(item => permissions.find(permission => permission.siteId == item.siteId && ![BASE_USER, BASE_CHECKER].includes(permission.roleId))) : null;

    return permissionItems;
}

export const haveAbilityToChangeSites = (permissions, documents) => {
    const permissionItems = permissions && documents ?
        documents.filter(document => permissions.find(item => item.siteId == document.siteId && !item.site.isRestricted && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId))) : null;

    return permissionItems;
}

export const allowedSiteListToChangeSites = (permissions, sites, currentSiteId, accountId) => {
    const permissionItems = permissions && sites ?
        sites.filter(site => permissions.find(item => item.siteId == site.siteId && site.accountId == accountId && site.siteId != currentSiteId && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(item.roleId))) : null;

    return permissionItems;
}

export const haveAbilityToDeleteComment = (permissions, document) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == document.siteId) : null;

    return permissionItem && ![BASE_USER, BASE_CHECKER, CONTRIBUTOR, CONTRIBUTOR_PLUS, RESTRICTED_CONTRIBUTOR].includes(permissionItem.roleId) ? true : false;
}

export const haveAbilityToDeleteChangeComment = (permissions, document) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == document.siteId) : null;
    const isUnderChangeUser = permissions ? permissions.find(item => item.userId == document.underChangeUserId) : null;
    return permissionItem && (![BASE_USER, BASE_CHECKER].includes(permissionItem.roleId) || isUnderChangeUser) ? true : false;
}

export const allowDeleteRevision = (permissions, document) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == document.siteId) : null;

    return permissionItem && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(permissionItem.roleId) ? true : false;
}

export const haveAbilityChangeDocument = (permissions, document) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == document.siteId) : null;

    return permissionItem && ![BASE_USER, BASE_CHECKER].includes(permissionItem.roleId) ? true : false;
}

export const haveAbilityRetireAndUnretireDocument = (permissions, document) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == document.siteId) : null;

    return permissionItem && ![BASE_USER, BASE_CHECKER].includes(permissionItem.roleId) ? true : false;
}

export const haveAbilityRetireAndUnretireDocuments = (permissions, documents) => {
    const permissionItems = permissions && documents ?
        documents.filter(item => permissions.find(permission => permission.siteId == item.siteId && ![BASE_USER, BASE_CHECKER].includes(permission.roleId))) : null;

    return permissionItems;
}

export const haveAbilityDeleteDocument = (permissions, document) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == document.siteId) : null;

    return permissionItem && [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR, MANAGER].includes(permissionItem.roleId) ? true : false;
}

export const haveAbilityDeleteDocuments = (permissions, documents) => {
    documents = documents ? documents.map(item => { return { ...item, ...item.documentFile, ...item.document } }) : null
    return documents.filter(doc => permissions.find(item => item.siteId == doc.siteId && [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR, MANAGER].includes(item.roleId)));
}

export const haveAbilityCreateJob = (permissions, document) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == document.siteId) : null;

    return permissionItem && ![BASE_USER, BASE_CHECKER].includes(permissionItem.roleId);
}

export const haveAbilityRenameDocument = (permissions, document) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == document.siteId) : null;

    return permissionItem && ![BASE_USER, BASE_CHECKER].includes(permissionItem.roleId);
}

export const haveAbilityCreateJobByList = (permissions, documents) => {
    const permissionItems = permissions && documents ?
        documents.filter(item => permissions.find(permission => item.siteId == permission.siteId && ![BASE_USER, BASE_CHECKER].includes(permission.roleId))) : null;

    return permissionItems;
}

export const haveAbilityOpenDocuments = (permissions, document) => {
    const permission = permissions.find(item => item.siteId == document.siteId);

    if (permission && [ADMINISTRATOR].includes(permission.roleId)) {
        return true;
    }

    return permission && ![BASE_USER, BASE_CHECKER].includes(permission.roleId)
        && (permission.roleId != RESTRICTED_CONTRIBUTOR || permission.roleId == RESTRICTED_CONTRIBUTOR && (permission.site.useIndividualDocumentPermission ? !document.restrictAccessToSource && !document.restrictAccessToSourceAndPdfFile : true))
        && (![RESTRICTED_CONTRIBUTOR].includes(permission.roleId) || [RESTRICTED_CONTRIBUTOR].includes(permission.roleId) && permission.site.useIndividualDocumentPermission ? !document.hideOnDashboard : permission.site.normalDocumentDownloadForRestrictedUser);
}

export const haveAbilityExportDocuments = (permissions, documents) => {
    const permissionItems = permissions && documents ?
        documents.filter(item => permissions.find(permission => permission.siteId == item.siteId && ![BASE_USER, BASE_CHECKER].includes(permission.roleId))) : null;

    return permissionItems;
}

export const haveAbilityCreateJobByMaxRole = (maxUserRole) => {
    return ![BASE_USER, BASE_CHECKER].includes(maxUserRole);
}

export const haveAbilityDownloadPdf = (permissions, document) => {
    document = { ...document, ...document.documentFile, ...document.document };
    const permission = permissions.find(item => item.siteId == document.siteId);
    return permission &&
        (permission.roleId != RESTRICTED_CONTRIBUTOR || (permission.roleId == RESTRICTED_CONTRIBUTOR && !permission.site.isRestricted || (permission.site.isRestricted && permission.site.useIndividualDocumentPermission ? !document.restrictAccessToSourceAndPdfFile : permission.site.normalDocumentDownloadForRestrictedUser)));
}

export const haveAbilityDownloadWorkpackItem = (permissions, document) => {
    document = { ...document, ...document.documentFile, ...document.document };
    const permission = permissions.find(item => item.siteId == document.siteId);
    return permission &&
        (permission.roleId != RESTRICTED_CONTRIBUTOR || (permission.roleId == RESTRICTED_CONTRIBUTOR && !permission.site.isRestricted || (permission.site.isRestricted && permission.site.useIndividualDocumentPermission ? !document.restrictAccessToSourceAndPdfFile : true)));
}

export const haveAbilityToDownloadPdfs = (permissions, documents) => {
    documents = documents ? documents.map(item => { return { ...item, ...item.documentFile, ...item.document } }) : null
    const documentItems = documents && permissions ?
        documents.filter(doc => permissions.find(item => item.siteId == doc.siteId &&
            (item.roleId != RESTRICTED_CONTRIBUTOR || (item.roleId == RESTRICTED_CONTRIBUTOR && item.site.useIndividualDocumentPermission ? !doc.restrictAccessToSourceAndPdfFile : item.site.normalDocumentDownloadForRestrictedUser)))) : null;

    return documentItems;
}

export const haveAbilityOpenJobDetails = (permissions, job, userId) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == job.siteId) : null;
    const assignedUserId = job.assignedUser?.id ?? job.assignedUserId;
    const authoriserUserId = job.authoriserUser?.id ?? job.authoriserUserId;
    const createdByUserId = job.createdByUser?.id ?? job.createdByUserId;
    const isWorkflowUser = isJobAwaitingApproval(job)
        ? authoriserUserId == userId || createdByUserId == userId
        : isJobApprovalRejected(job)
            ? createdByUserId == userId
            : assignedUserId == userId;

    return permissionItem ? [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR, MANAGER].includes(permissionItem.roleId) || isWorkflowUser : false;
}

export const haveAbilityEditJobDetails = (permissions, jobs, userId) => {
    return permissions && jobs ? jobs.filter(job => {
        const permission = permissions.find(item => item.siteId == job.siteId);
        if (!permission) return false;

        if (hasJobApprovalWorkflowHold(job)) {
            return permission.roleId === ADMINISTRATOR
                || (job.createdByUser?.id ?? job.createdByUserId) == userId;
        }

        return [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR, MANAGER].includes(permission.roleId)
            || (job.assignedUser?.id ?? job.assignedUserId) == userId;
    }) : null;
}

export const displayActionsOnApproval = (permissions, documents) => {
    documents = documents ? documents.map(item => { return { ...item, ...item.documentFile, ...item.document } }) : null
    const documentItems = documents && permissions ?
        documents.filter(doc => permissions.find(item => item.siteId == doc.siteId && ![CONTRIBUTOR, RESTRICTED_CONTRIBUTOR, BASE_CHECKER, BASE_USER, CONTRIBUTOR_PLUS].includes(item.roleId))) : null;

    return documentItems;
}

export const allowShowSiteDetails = (permissions, siteId) => {
    const permissionItem = permissions ? permissions.find(item => item.siteId == siteId) : null;
    return permissionItem ? [ADMINISTRATOR, MANAGER, MANAGER_PLUS, SUPERVISOR].includes(permissionItem.roleId) : false;
}

export const allowApproveDocuments = (permissions, documents) => {
    documents = documents ? documents.map(item => { return { ...item, ...item.documentFile, ...item.document } }) : null
    const documentItems = documents && permissions ?
        documents.filter(item => permissions.find(perm => item.siteId == perm.siteId && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, CONTRIBUTOR_PLUS].includes(perm.roleId) && item.documentFileStatusId != 4)) : null;

    return documentItems
}

export const allowApproveJobs = (permissions, jobs) => {
    return jobs && permissions
        ? jobs.filter(item =>
            isJobAwaitingApproval(item)
            && permissions.find(perm =>
                item.siteId == perm.siteId
                && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, CONTRIBUTOR_PLUS].includes(perm.roleId)
            )
        )
        : null;
}

export const allowReassignDocuments = (permissions, documents, hasGlobalAdministratorPrivileges = false) => {
    documents = documents ? documents.map(item => { return { ...item, ...item.documentFile, ...item.document } }) : null
    const documentItems = documents && permissions ? documents.filter(item =>
        hasGlobalAdministratorPrivileges || permissions.some(perm =>
            item.siteId == perm.siteId && [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR, MANAGER].includes(perm.roleId))) : null;

    return documentItems
}

export const allowDeleteItemFromDistributionDashboard = (maxUserRole) => {
    return maxUserRole == ADMINISTRATOR;
}

export const allowReassignCheckers = (permissions, items) => {
    return permissions && items ? items.filter(item => permissions.find(permission => permission.siteId == item.siteId && [MANAGER, MANAGER_PLUS, SUPERVISOR, ADMINISTRATOR].includes(permission.roleId))) : null;
}

export const allowDistributionDashboardFilter = (permissions, accountId) => {
    return permissions ? permissions.find(item => (item.site.accountId == accountId && [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR, MANAGER].includes(item.roleId)) || item.roleId == ADMINISTRATOR) : false;
}

export const haveAbilityChangeDocumentNumberSystemSetup = (permissions, docSetup) => {
    return permissions ? permissions.find(item => item.siteId == docSetup.siteId && [ADMINISTRATOR, MANAGER_PLUS, SUPERVISOR, MANAGER, RESTRICTED_CONTRIBUTOR, CONTRIBUTOR, CONTRIBUTOR_PLUS].includes(item.roleId)) : false;
}

export const canDeleteDocumentNumberSystemSetup = (permissions, docsSetup) => {
    return permissions ? docsSetup.filter(doc => permissions.find(perm => doc.siteId == perm.siteId && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR, RESTRICTED_CONTRIBUTOR, CONTRIBUTOR, CONTRIBUTOR_PLUS].includes(perm.roleId))) : null;
}

export const canReallocateJobs = (permissions, items, userId) => {
    return items ? items.filter(item => !hasJobApprovalWorkflowHold(item)
        && permissions.find(perm => perm.siteId == item.siteId && ([ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR, RESTRICTED_CONTRIBUTOR, CONTRIBUTOR, CONTRIBUTOR_PLUS].includes(perm.roleId) || (item.createdByUser?.id ?? item.createdByUserId) == userId))) : null;
}

export const canReallocateJobAuth = (permissions, items, userId) => {
    return items ? items.filter(item => isJobAwaitingApproval(item)
        && (permissions.find(perm => perm.siteId == item.siteId && [ADMINISTRATOR, MANAGER_PLUS, MANAGER, SUPERVISOR].includes(perm.roleId))
            || (item.createdByUser?.id ?? item.createdByUserId) == userId)) : null;
}

export const canAuthorizeJobs = (permissions, items, userId) => {
    return items ? items.filter(item => isJobAwaitingApproval(item)
        && (item.authoriserUser?.id ?? item.authoriserUserId) == userId
        && permissions.find(perm => perm.siteId == item.siteId && [MANAGER_PLUS, MANAGER].includes(perm.roleId))) : null;
}

export const canReleaseJobs = (permissions, items, userId) => {
    return items ? items.filter(item => permissions.find(perm => perm.siteId == item.siteId && ([ADMINISTRATOR].includes(perm.roleId) || item.createdByUser.Id == userId))) : null;
}

export const canRemoveJobs = (permissions, items, userId) => {
    return items ? items.filter(item => permissions.find(perm => perm.siteId == item.siteId && ([ADMINISTRATOR].includes(perm.roleId) || item.createdByUser.Id == userId))) : null;
}

export const canModifyQuote = (permissions, items, userId) => {
    return items ? items.filter(item => permissions.find(perm => perm.siteId == item.siteId && ([ADMINISTRATOR].includes(perm.roleId) || item.assignedUser.Id == userId))) : null;
}
